export default function MySQL_CURTIME() {
  return (
    <div>
      <h2>MySQL_CURTIME</h2>    </div>
  );
}